import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ONE_MODELS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { OneModelsDataActionTypes } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadOneModels =
  (
    id: string,
  ): ThunkAction<Promise<void>, State, null, OneModelsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: ONE_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadOneModels(id);
      dispatch({ type: ONE_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ONE_MODELS + FAILURE, error });
    }
  };
